import { getHreflangs } from "./getHreflangs";
import type { Hreflang } from "./getHreflangs.d";

export { getHreflangs };
export type { Hreflang };
